
import React from "react";
import { Settings2 } from "lucide-react";

interface PreferencesSectionProps {
  preferencesData: any;
  aiContext?: any;
}

export default function PreferencesSection({ preferencesData, aiContext }: PreferencesSectionProps) {
  if (!preferencesData) return null;
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-white/90 flex items-center gap-2 border-b border-white/20 pb-2">
        <Settings2 className="h-5 w-5" />
        Preferences & Customizations
      </h3>
      
      <div className="space-y-5">
        {preferencesData.periodizationType && (
          <div className="space-y-2">
            <div className="flex">
              <span className="text-white/80 w-40">Periodization Type:</span>
              <span className="text-white">{preferencesData.periodizationType}</span>
            </div>
            {preferencesData.periodizationDescription && (
              <div className="flex">
                <span className="text-white/80 w-40">Description:</span>
                <span className="text-white">{preferencesData.periodizationDescription}</span>
              </div>
            )}
          </div>
        )}
        
        {preferencesData.likedExercises && preferencesData.likedExercises.length > 0 && (
          <div className="space-y-2">
            <h4 className="text-white font-medium">Preferred Exercises:</h4>
            <ul className="list-disc list-inside text-white">
              {preferencesData.likedExercises.map((exercise: string, index: number) => (
                <li key={`liked-${index}`}>{exercise}</li>
              ))}
            </ul>
          </div>
        )}
        
        {preferencesData.dislikedExercises && preferencesData.dislikedExercises.length > 0 && (
          <div className="space-y-2">
            <h4 className="text-white font-medium">Exercises to Avoid:</h4>
            <ul className="list-disc list-inside text-white">
              {preferencesData.dislikedExercises.map((exercise: string, index: number) => (
                <li key={`disliked-${index}`}>{exercise}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
